// extracted by mini-css-extract-plugin
export default {"zoomModal":"t3-z"};